
import { supabase } from "@/integrations/supabase/client";

// Interface pour les données du paiement
interface PaymentData {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  city: string;
  postalCode: string;
  membershipType: "active" | "benefactor" | "donor";
  amount: number;
  additionalDonation: number;
  acceptNewsletter?: boolean;
  membershipId?: string; // Optionnel: ID de l'adhésion existante
}

// Créer une session de paiement Stripe via la fonction Edge
export async function createStripePayment(paymentData: PaymentData) {
  console.log("Création d'une session de paiement Stripe avec les données:", paymentData);
  
  try {
    console.log("Mode de paiement: PRODUCTION");
    
    // Ajouter un paramètre pour indiquer l'environnement de production
    const result = await supabase.functions.invoke("create-stripe-payment", {
      body: {
        ...paymentData,
        mode: "production" // Cela indiquera à la fonction edge d'utiliser la clé de production
      }
    });
    
    console.log("Résultat de l'appel à la fonction create-stripe-payment:", result);
    
    const { data, error } = result;
    
    if (error) {
      console.error("Erreur lors de l'appel à la fonction create-stripe-payment:", error);
      throw new Error(`Erreur lors de la création de la session de paiement: ${error.message || error}`);
    }
    
    if (!data) {
      console.error("Aucune donnée renvoyée par la fonction create-stripe-payment");
      throw new Error("Aucune donnée de session n'a été renvoyée");
    }
    
    if (data.error) {
      console.error("Erreur renvoyée par la fonction create-stripe-payment:", data.error);
      throw new Error(`Erreur Stripe: ${data.error}`);
    }
    
    console.log("Session de paiement créée avec succès:", data);
    
    // Store the session ID in localStorage for retrieval in case of page refresh
    if (data.sessionId) {
      localStorage.setItem("stripe_session_id", data.sessionId);
      console.log("Session ID stored in localStorage:", data.sessionId);
    }
    
    return {
      sessionId: data.sessionId,
      sessionUrl: data.sessionUrl
    };
  } catch (error) {
    console.error("Exception lors de la création de la session de paiement:", error);
    throw error;
  }
}
